import React from 'react';
import ButtonComponent from "../Button";
import {Carousel} from "antd";
import acc from "accounting";
import './styles.less';

const data = [
    {
        "name": "Sleek",
        "description": "Sleek. An elegant, interactive theme for modern beauty brands",
        "average_rating": acc.formatNumber(441/442, 2, ',', '.'),
        "link": "https://themes.shopify.com/themes/sleek/presets/sleek?surface_inter_position=1&surface_intra_position=2&surface_type=all",
        "icon": "https://cdn.shopify.com/theme-store/pvmgajxpnqxcbb3wkw297uwsflu7.jpg?width=684",
        "review_count": 442
    },
    {
        "name": "Hyper",
        "description": "Power and Scalability for High-Growth B2B and Wholesale Brands",
        "average_rating": acc.formatNumber(271/274, 2, ',', '.'),
        "link": "https://themes.shopify.com/themes/hyper/presets/hyper?surface_inter_position=1&surface_intra_position=3&surface_type=all",
        "icon": "https://cdn.shopify.com/theme-store/l2jo4nmthucu3820g9w23rjkbmqa.jpg?width=684",
        "review_count": 274
    },
    {
        "name": "Palo Alto",
        "description": "Exceptional design and powerful features to elevate your brand",
        "average_rating": acc.formatNumber(281/300, 2, ',', '.'),
        "link": "https://themes.shopify.com/themes/palo-alto/presets/palo-alto?surface_inter_position=1&surface_intra_position=4&surface_type=all",
        "icon": "https://cdn.shopify.com/theme-store/apezhhjeaprkemz5cwz9psj705a0.jpg?width=684",
        "review_count": 300
    },
    {
        "name": "Impulse",
        "description": "Flexible, fashionable, proven design with powerful promotions.",
        "average_rating": acc.formatNumber(441/442, 2, ',', '.'),
        "link": "https://themes.shopify.com/themes/sleek/presets/sleek?surface_inter_position=1&surface_intra_position=2&surface_type=all",
        "icon": "https://cdn.shopify.com/theme-store/6uqf7q8cqnb5133bemlq0v7twkyh.jpg?width=684",
        "review_count": 442
    },
    {
        "name": "Stiletto",
        "description": "The ultimate luxury fashion theme, offering style and power",
        "average_rating": acc.formatNumber(116/127, 2, ',', '.'),
        "link": "https://themes.shopify.com/themes/stiletto/presets/stiletto?surface_inter_position=1&surface_intra_position=6&surface_type=all",
        "icon": "https://cdn.shopify.com/theme-store/ba2hneg2owq50qa7ssz46c1j33i1.jpg?width=684",
        "review_count": 127
    },
    {
        "name": "Xtra",
        "description": "A versatile theme fit for every industry built for boosting conversion",
        "average_rating": acc.formatNumber(361/366, 2, ',', '.'),
        "link": "https://themes.shopify.com/themes/xtra/presets/xtra?surface_inter_position=1&surface_intra_position=7&surface_type=all",
        "icon": "https://cdn.shopify.com/theme-store/ey2a48okn7jd50gf74lgzxxhd1j1.jpg?width=684",
        "review_count": 366
    },
    {
        "name": "Concept",
        "description": "The seamless mobile shopping experience for your customers.",
        "average_rating": acc.formatNumber(489/494, 2, ',', '.'),
        "link": "https://themes.shopify.com/themes/concept/presets/concept?surface_inter_position=1&surface_intra_position=8&surface_type=all",
        "icon": "https://cdn.shopify.com/theme-store/e42mbv49d6nc4txtpzff2aaloprx.jpg?width=684",
        "review_count": 494
    },
    {
        "name": "Shapes",
        "description": "Move products fast with clever Shapes.",
        "average_rating": acc.formatNumber(75/75, 2, ',', '.'),
        "link": "https://themes.shopify.com/themes/shapes/presets/shapes?surface_inter_position=1&surface_intra_position=9&surface_type=all",
        "icon": "https://cdn.shopify.com/theme-store/nmqrckz59sdaar0ct83udek1cmq6.jpg?width=684",
        "review_count": 75
    },
    {
        "name": "Be Yours",
        "description": "Refined theme for modern brands: elegant, intuitive & built to convert",
        "average_rating": acc.formatNumber(620/636, 2, ',', '.'),
        "link": "https://themes.shopify.com/themes/be-yours/presets/be-yours?surface_inter_position=1&surface_intra_position=10&surface_type=all",
        "icon": "https://cdn.shopify.com/theme-store/4oorrxewfllecf8gj08heacdddgp.jpg?width=684",
        "review_count": 636
    },
    {
        "name": "Symmetry",
        "description": "Versatile, fashionable, professional theme with premium features.",
        "average_rating": acc.formatNumber(358/376, 2, ',', '.'),
        "link": "https://themes.shopify.com/themes/symmetry/presets/symmetry?surface_inter_position=1&surface_intra_position=11&surface_type=all",
        "icon": "https://cdn.shopify.com/theme-store/dj581wl4mm4kgr2dz5org4m2lalm.jpg?width=684",
        "review_count": 376
    },
    {
        "name": "Release",
        "description": "Boldly Unique, Lightning-Fast Impact",
        "average_rating": acc.formatNumber(77/83, 2, ',', '.'),
        "link": "https://themes.shopify.com/themes/release/presets/release?surface_inter_position=1&surface_intra_position=12&surface_type=all",
        "icon": "https://cdn.shopify.com/theme-store/uhky1qchmkhrxqua3ynspfjn0d5c.jpg?width=684",
        "review_count": 83
    },
    {
        "name": "Ultra",
        "description": "Sleek, high-performance design for bold, modern online storefronts.",
        "average_rating": acc.formatNumber(21/23, 2, ',', '.'),
        "link": "https://themes.shopify.com/themes/ultra/presets/ultra?surface_inter_position=1&surface_intra_position=13&surface_type=all",
        "icon": "https://cdn.shopify.com/theme-store/omdflfb9j1yrv5nj3b06rhbrgldz.jpg?width=684",
        "review_count": 23
    },
    {
        "name": "Wonder",
        "description": "Sell more with good UX and shoppable video features.",
        "average_rating": acc.formatNumber(105/105, 2, ',', '.'),
        "link": "https://themes.shopify.com/themes/wonder/presets/wonder?surface_inter_position=1&surface_intra_position=14&surface_type=all",
        "icon": "https://cdn.shopify.com/theme-store/0uxc3py9xb5a8zclq9xpgs7ibbos.jpg?width=684",
        "review_count": 105
    },
    {
        "name": "Eurus",
        "description": "Flexible, fast, and expert-crafted to maximize your store's potential.",
        "average_rating": acc.formatNumber(433/435, 2, ',', '.'),
        "link": "https://themes.shopify.com/themes/eurus/presets/eurus?surface_inter_position=1&surface_intra_position=16&surface_type=all",
        "icon": "https://cdn.shopify.com/theme-store/41i3foe2uuaq6t3h0tzm52q4lrl2.jpg?width=684",
        "review_count": 261
    },
    {
        "name": "Enterprise",
        "description": "A new benchmark in store speed and conversion. Sell faster, sell more.",
        "average_rating": acc.formatNumber(90/98, 2, ',', '.'),
        "link": "https://themes.shopify.com/themes/enterprise/presets/enterprise?surface_inter_position=1&surface_intra_position=17&surface_type=all",
        "icon": "https://cdn.shopify.com/theme-store/bflkc9mo15enoyrw06c8nafbqnfe.jpg?width=684",
        "review_count": 98
    },
    {
        "name": "Prestige",
        "description": "Designed for premium, high-end brand appeal.",
        "average_rating": acc.formatNumber(735/811, 2, ',', '.'),
        "link": "https://themes.shopify.com/themes/prestige/presets/prestige?surface_inter_position=1&surface_intra_position=18&surface_type=all",
        "icon": "https://cdn.shopify.com/theme-store/idam693xh6c71d2l2pam6w9h09oe.jpg?width=684",
        "review_count": 811
    },
]

const Index = ({isMobile, skeleton}) => {

    const getRandomItems = (array, n) => {
        const result = [...array];
        for (let i = result.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [result[i], result[j]] = [result[j], result[i]];
        }
        return result.slice(0, n);
    };

    if (skeleton) return (
        <div className="top-themes">
            <span className={'link-skeleton'} style={{width: 300, height: 45}}/>
            <span className={'link-skeleton'} style={{width: '100%', height: 48, maxWidth: 720, marginTop: 12}}/>
            {
                isMobile ?
                    <div className="top-themes-container">
                        <div className="theme-wrapper">
                            <div className="image">
                                <span className={'link-skeleton'}
                                      style={{width: '100%', height: '100%', borderRadius: 16}}/>
                            </div>
                            <div className="data">
                                <div className="title-wrapper">
                                        <span className="title">
                                            <span className={'link-skeleton'} style={{width: 28, height: 24}}/>
                                        </span>
                                    <span className="rating">
                                            <span>
                                                <span className={'link-skeleton'} style={{width: 22, height: 20}}/>
                                            </span>
                                            <span className={'link-skeleton'} style={{width: 16, height: 16}}/>
                                            <span>
                                                <span className={'link-skeleton'} style={{width: 50, height: 20}}/>
                                            </span>
                                        </span>
                                </div>
                                <p className="description">
                                    <span className={'link-skeleton'} style={{width: '100%', height: 40}}/>
                                </p>
                                <span className={'link-skeleton'} style={{width: '100%', height: 40}}/>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="top-themes-container">
                        {
                            [1, 2, 3, 4, 5, 6, 7, 8].map(el => (
                                <div className="theme-wrapper"
                                     key={el}
                                >
                                    <div className="image">
                                        <span className={'link-skeleton'}
                                              style={{width: '100%', height: '100%', borderRadius: 16}}/>
                                    </div>
                                    <div className="data"
                                         style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}
                                    >
                                        <span className="title">
                                            <span className={'link-skeleton'} style={{width: 58, height: 24}}/>
                                        </span>
                                        <span className="rating"
                                              style={{display: 'flex', alignItems: 'center', gap: 4}}
                                        >
                                            <span>
                                                <span className={'link-skeleton'} style={{width: 22, height: 20}}/>
                                            </span>
                                            <span className={'link-skeleton'} style={{width: 16, height: 16}}/>
                                            <span>
                                                <span className={'link-skeleton'} style={{width: 50, height: 20}}/>
                                            </span>
                                        </span>
                                    </div>
                                    <p className="description">
                                        <span className={'link-skeleton'} style={{width: '100%', height: 40}}/>
                                    </p>
                                    <span className={'link-skeleton'} style={{width: '100%', height: 40}}/>
                                </div>
                            ))
                        }
                    </div>
            }
        </div>
    )

    return (
        <div className="top-themes">
            <h3>
                Top Shopify themes
            </h3>
            <p>
                Explore Shopify’s best-rated themes loved by eCommerce brands worldwide. Build your store with a design
                proven to engage customers and drive sales.
            </p>
            {
                isMobile ?
                    <div className="top-themes-container">
                        <Carousel autoplay={true}
                                  infinite={true}
                        >
                            {
                                getRandomItems(data, 8).map((item) => (
                                    <div className="theme-wrapper"
                                         key={item.name}
                                    >
                                        <div className="image">
                                            <img src={item?.icon}
                                                 onError={e => {
                                                     e.target.src = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M12.6667 4.66675C10.0893 4.66675 8 6.75609 8 9.33342C8 11.9107 10.0893 14.0001 12.6667 14.0001C15.244 14.0001 17.3333 11.9107 17.3333 9.33342C17.3333 6.75609 15.244 4.66675 12.6667 4.66675Z" fill="#225AEA"/><path d="M28.4964 19.9243C27.5549 17.4568 26.5763 15.4997 25.5596 14.1606C24.5753 12.8641 23.3564 11.8946 21.9168 12.0139C19.4325 12.2197 17.7574 14.2506 16.5742 15.8011C16.4106 16.0155 16.2563 16.2214 16.1088 16.4181C15.6747 16.9971 15.2999 17.4969 14.9246 17.9004C14.3986 18.4657 14.118 18.5584 13.9993 18.5584C13.75 18.5584 13.4472 18.4727 13.0432 18.264C12.6788 18.0759 12.3082 17.8302 11.87 17.5397L11.6977 17.4256C10.7443 16.7953 9.46082 15.9612 7.91686 15.9612C6.78022 15.9612 5.87277 16.6407 5.20608 17.3972C4.52616 18.1687 3.95783 19.1733 3.49657 20.1659L3.40983 20.3521C2.86212 21.5266 2.41724 22.4806 2.60704 23.6083C2.68802 24.0896 2.89669 24.5622 3.15047 24.96C3.40426 25.3578 3.74497 25.7462 4.14723 26.0225C4.67216 26.3829 5.24167 26.5329 5.86118 26.6018C6.44311 26.6666 7.15175 26.6665 7.98824 26.6665H23.7134C24.6305 26.6665 25.3907 26.6665 26.0023 26.6072C26.6371 26.5456 27.2289 26.4119 27.7566 26.0657C28.5319 25.5571 29.128 24.6916 29.3268 23.786C29.46 23.179 29.3855 22.5991 29.2257 22.0034C29.0738 21.4375 28.8187 20.7689 28.5145 19.9717L28.4964 19.9243Z" fill="#225AEA"/></svg>';
                                                 }}
                                                 alt="theme-icon"
                                            />
                                        </div>
                                        <div className="data">
                                            <div className="title-wrapper">
                                <span className="title">
                                    {item?.name}
                                </span>
                                                <span className="rating">
                                        <span>
                                            {acc.formatNumber(item?.average_rating * 5, 1, ',', '.')}
                                        </span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                             viewBox="0 0 16 16" fill="none"><path
                                            d="M8.91502 1.24156C8.54684 0.475144 7.45313 0.475141 7.08495 1.24156L5.51021 4.5196L1.88306 4.99452C1.04215 5.10463 0.69201 6.1437 1.31812 6.73407L3.96872 9.23338L3.30352 12.8017C3.14558 13.6489 4.0425 14.277 4.7835 13.8775L7.99998 12.1435L11.2165 13.8775C11.9575 14.277 12.8544 13.6489 12.6965 12.8017L12.0312 9.23338L14.6819 6.73407C15.308 6.1437 14.9578 5.10463 14.1169 4.99452L10.4898 4.5196L8.91502 1.24156Z"
                                            fill="#F6B60E"/></svg>
                                        <span>
                                            ({item?.review_count})
                                        </span>
                                </span>
                                            </div>
                                            <p className="description">
                                                {item?.description}
                                            </p>
                                            <ButtonComponent onClick={() => window.open(item?.link, '_blank')}
                                                             className="view-btn"
                                            >
                                                View this theme
                                            </ButtonComponent>
                                        </div>
                                    </div>
                                ))
                            }
                        </Carousel>
                    </div>
                    :
                    <div className="top-themes-container">
                        {
                            getRandomItems(data, 8).map((item) => (
                                <div className="theme-wrapper"
                                     key={item.name}
                                >
                                    <div className="image">
                                        <img src={item?.icon}
                                             onError={e => {
                                                 e.target.src = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M12.6667 4.66675C10.0893 4.66675 8 6.75609 8 9.33342C8 11.9107 10.0893 14.0001 12.6667 14.0001C15.244 14.0001 17.3333 11.9107 17.3333 9.33342C17.3333 6.75609 15.244 4.66675 12.6667 4.66675Z" fill="#225AEA"/><path d="M28.4964 19.9243C27.5549 17.4568 26.5763 15.4997 25.5596 14.1606C24.5753 12.8641 23.3564 11.8946 21.9168 12.0139C19.4325 12.2197 17.7574 14.2506 16.5742 15.8011C16.4106 16.0155 16.2563 16.2214 16.1088 16.4181C15.6747 16.9971 15.2999 17.4969 14.9246 17.9004C14.3986 18.4657 14.118 18.5584 13.9993 18.5584C13.75 18.5584 13.4472 18.4727 13.0432 18.264C12.6788 18.0759 12.3082 17.8302 11.87 17.5397L11.6977 17.4256C10.7443 16.7953 9.46082 15.9612 7.91686 15.9612C6.78022 15.9612 5.87277 16.6407 5.20608 17.3972C4.52616 18.1687 3.95783 19.1733 3.49657 20.1659L3.40983 20.3521C2.86212 21.5266 2.41724 22.4806 2.60704 23.6083C2.68802 24.0896 2.89669 24.5622 3.15047 24.96C3.40426 25.3578 3.74497 25.7462 4.14723 26.0225C4.67216 26.3829 5.24167 26.5329 5.86118 26.6018C6.44311 26.6666 7.15175 26.6665 7.98824 26.6665H23.7134C24.6305 26.6665 25.3907 26.6665 26.0023 26.6072C26.6371 26.5456 27.2289 26.4119 27.7566 26.0657C28.5319 25.5571 29.128 24.6916 29.3268 23.786C29.46 23.179 29.3855 22.5991 29.2257 22.0034C29.0738 21.4375 28.8187 20.7689 28.5145 19.9717L28.4964 19.9243Z" fill="#225AEA"/></svg>';
                                             }}
                                             alt="theme-icon"
                                        />
                                    </div>
                                    <div className="data">
                                        <div className="title-wrapper">
                                <span className="title">
                                    {item?.name}
                                </span>
                                            <span className="rating">
                                        <span>
                                            {acc.formatNumber(item?.average_rating * 5, 1, ',', '.')}
                                        </span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                             viewBox="0 0 16 16" fill="none"><path
                                            d="M8.91502 1.24156C8.54684 0.475144 7.45313 0.475141 7.08495 1.24156L5.51021 4.5196L1.88306 4.99452C1.04215 5.10463 0.69201 6.1437 1.31812 6.73407L3.96872 9.23338L3.30352 12.8017C3.14558 13.6489 4.0425 14.277 4.7835 13.8775L7.99998 12.1435L11.2165 13.8775C11.9575 14.277 12.8544 13.6489 12.6965 12.8017L12.0312 9.23338L14.6819 6.73407C15.308 6.1437 14.9578 5.10463 14.1169 4.99452L10.4898 4.5196L8.91502 1.24156Z"
                                            fill="#F6B60E"/></svg>
                                        <span>
                                            ({item?.review_count})
                                        </span>
                                </span>
                                        </div>
                                        <p className="description">
                                            {item?.description}
                                        </p>
                                        <ButtonComponent onClick={() => window.open(item?.link, '_blank')}
                                                         className="view-btn"
                                        >
                                            View this theme
                                        </ButtonComponent>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
            }
        </div>
    );
};

export default Index;